export default "<div>\n  <h1>404: page missing</h1>\n</div>"